import ProductPage from '@/pages/Product.vue';
import ProductGallery from '@/modules/product/components/ProductGallery.vue';
import ProductActions from '@/modules/product/containers/ProductActions.vue';
import ProductInfo from '@/modules/product/components/ProductInfo.vue';
import ProductShare from '@/modules/product/containers/ProductShare.vue';
import SetProductState from '@/modules/product/SetProductState';
const ProductPlugin = {};
ProductPlugin.install = function (Vue) {
    Vue.component('changirecommends-product-page', ProductPage);
    Vue.component('product-gallery', ProductGallery);
    Vue.component('product-actions', ProductActions);
    Vue.component('product-info', ProductInfo);
    Vue.component('product-share', ProductShare);
    Vue.component('set-product-state', SetProductState);
};
export default ProductPlugin;
